import { createContext, useContext } from 'react';

interface PacotesListContextType {
  data: Omit<PacoteDataType, 'destinos' | 'category' | 'pacote'>;
}

const PacotesListContext = createContext<PacotesListContextType>({} as PacotesListContextType);

export const usePacotesListContext = () => {
  return useContext(PacotesListContext);
};

export default PacotesListContext;
